import { io } from "socket.io-client";
// import { reactive } from "vue";

// const URL = process.env.VUE_APP_SOCKET_URL ?? 'http://192.168.162.30:3000';
const URL = process.env.VUE_APP_SOCKET_URL ?? 'http://127.0.0.1:3000';

// export const socketState = reactive({
//     isConnect:false,
//     newEvent:false,

// })

export const socket = io(URL)

